export const MATCH_TYPES = {
    X01: 1,
    CRICKET: 3,
    TACTICS: 3,
    KILLER: 4,
    CAMELRACE: 7,
    SEGMENTS: 8, // TODO: Verify which number it should be
}

export const MATCH_TYPE_NAMES = {
    [MATCH_TYPES.X01]: 'X01',
    2: 'X01', // 301 is part of the X01 family
    [MATCH_TYPES.CRICKET]: 'Cricket',
    [MATCH_TYPES.KILLER]: 'Killer',
    [MATCH_TYPES.CAMELRACE]: 'Camelrace',
    [MATCH_TYPES.SEGMENTS]: 'Segments',
}

/**
 * Resolve a match type's display name from its id, falling back to a provided
 * name (e.g. the snapshotted matchtype_name on older notifications that don't
 * carry the id).
 */
export function matchTypeName(matchTypeId, fallback = 'match') {
    return MATCH_TYPE_NAMES[matchTypeId] || fallback
}

// Match types that support the audio announcer
export const ANNOUNCER_ENABLED_MATCH_TYPES = new Set([MATCH_TYPES.X01])
